import { render } from "./PrivacyPolicy.vue?vue&type=template&id=7fc6bb3c&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=7fc6bb3c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/azia2012/azia2012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc6bb3c"]])

export default __exports__